<template>

    <div id="mobile-header">
        <svgicon :src="$store.state.pageIcon" class="icon" width="20" height="20"></svgicon>
        <div class="page">{{pageTitle}}</div>
        <div class="subtitle" v-if="$store.state.loggedUser.isReceptionUser && $store.state.contextCompany">
            {{$store.state.contextCompany.name}}
        </div>
        <template v-if="hasActionPages" >
            <svgicon v-if="!menuVisible" src="/icon/hamburger.svg" class="menu-icon" height="20" width="20" @click="toggleMenu"></svgicon>
            <svgicon v-if="menuVisible" src="/icon/close.svg" class="menu-icon" height="20" width="20" @click="toggleMenu"></svgicon>
        </template>
        <div class="menu-container" :class="{visible: menuVisible}" @click.self="toggleMenu">
            <div class="menu">
                <div class="buttons">
                    <div class="btn-server" v-if="accessibleServers">
                        <div class="country" v-if="$store.state.contextCompany && $store.state.contextCompany.country">
                            <svgicon :src="'/icon/country/' + $store.state.contextCompany.country + '.svg'" :width="40" :height="40"></svgicon>
                        </div>
                        <div class="server">
                            <select v-model="contextServer">
                                <option :value="server" v-for="server of accessibleServers">{{server.name}}</option>
                            </select>
                        </div>
                    </div>
                    <button class="btn"
                            v-for="(action, actionIndex) of $store.state.currentPageActions"
                            :key="'action-' + actionIndex"
                            @click="(function(){ action.method ? action.method() : function(){}; toggleMenu(); })()">
                        {{ $t(action.text) }}
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
  export default {

    name: "mobileheader",

    data() {
      return {
        menuVisible: false
      };
    },
    computed: {
      pageTitle() {
        return this.$t(this.$store.state.pageTitleTranslationKey);
      },
      accessibleServers() {
        return this.$store.state.loggedUser.accessibleServers
      },
      hasActionPages() {
        return this.$store.state.currentPageActions.length > 0;
      },
      contextServer: {
        get() {
            return this.$store.state.contextServer
        },
        set(server) {
            this.toggleMenu();
            this.$store.commit('setContextServer', server);
            let defaultRoute = this.$store.getters.defaultRouting;
            this.$route.path === defaultRoute.path
              ? this.$router.go() /* refresh when same route */
              : this.$router.push(defaultRoute).catch(()=>{});
        }
      }
    },
    methods: {
      toggleMenu() {
        if (this.hasActionPages) {
            this.menuVisible = !this.menuVisible;
        } else {
          this.menuVisible = false;
        }
      }
    }
  };
</script>


<style lang="scss" scoped>

    #mobile-header {
        background-color: white;
        display: flex;
        padding: 20px 10px;
        align-items: center;
        font-size: 16px;
        margin-top: 56px;
        flex-shrink: 0;
        position: relative;
        overflow: visible;
    }
    .icon {
        margin-right: 20px;
    }
    .svgicon {
        fill: #bfbfbf;
    }
    .page {
        font-weight: bold;
        font-size: 20px;
        padding-right: 20px;
        position: relative;
        flex-grow: 1;
    }
    .subtitle {
        flex-grow: 1;
        color: #808080;
        position: relative;

        &:before {
            content: "";
            position: absolute;
            flex-shrink: 0;
            height: 100%;
            min-height: 14px;
            width: 1px;
            left: -10px;
            min-width: 1px;
            background-color: #bfbfbf;
        }
    }
    .menu-container {
        visibility: hidden;
        position: fixed;
        left: 0;
        right: 0;
        top: 145px;
        background-color: rgba(0,0,0,0);
        z-index: 100;
        width: 100%;
        height: 100%;
        .menu {
            display:none;
            position: absolute;
            top: 0;
            right: 0;
            z-index: 102;
            width: 400px;
            animation: growDown 150ms ease-out;
            transform-origin: top right;
            @keyframes growDown {
                0% {
                    transform: scaleY(0)
                }
                75% {
                    transform: scaleY(1.05)
                }
                100% {
                    transform: scaleY(1)
                }
            }
        }

        &.visible {
            visibility: visible;
            background-color: rgba(0,0,0,0.5);
            transition: visibility 0s, background .2s ease-out;
            .menu {
                display: block;
            }
        }

        &:not(.visible) {
            transition: visibility 0.03s, background 0.03s ease-out;
        }
    }
    .buttons {
        padding: 20px;
        background-color: white;
        border-top: 2px solid #e6e6e6;
        display: flex;
        flex-direction: column;
    }
    .btn-server {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 10px;

        .country {
            padding-right: 20px
        }
        .server {
            flex-grow: 1;
            select {
                width: 100%;
            }
        }
    }
    .btn {
        background-color: #f5f5f5;
        border-radius: 5px;
        margin-bottom: 10px;

        &:last-child {
            margin-bottom: 0;
        }
    }
    .menu-icon {
        transition: transform 0.2s ease-in-out;
        transform: rotate(180deg);

        &.rotate {
            transform: rotate(0deg);
        }
    }

    @media screen and (max-width: 450px) {
        .subtitle {
            display: none;
        }
    }

    @media (max-width: 400px) {
        .menu-container .menu {
            width: 100%;
        }
    }
</style>
